/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_DistributableFeatureResponseDto } from '../models/Wealthlane_Dtos_DistributableFeatureResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DistributableFeatureService {

    /**
     * @param distributableCompanyId 
     * @returns Wealthlane_Dtos_DistributableFeatureResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiDistributableFeatures(
distributableCompanyId: string,
): CancelablePromise<Wealthlane_Dtos_DistributableFeatureResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/distributable-features/{distributableCompanyId}',
            path: {
                'distributableCompanyId': distributableCompanyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
